lmApp
  .service('DrmService', ['$rootScope',
    function ($rootScope) {
      var service = {};

      service.GetVerimatrix = function () {
        var data = window.localStorage['verimatrix'];
        if (!data || data === 'undefined') {
          data = {
            serverAddress: '72.62.179.10',
            port: 12684,
            keyReqTimeout: 10,
            httpApiPass: '****',
            httpApiConfirm: '****',
            enableRandKey: true,
            enableRandResourceId: true,
            nodes: [
              {
                sourceDesc: 'VCAS Private',
                liveResourceIdRange: [1000, 2000],
                vodResourceIdRange: [2001, 30000]
              }
            ]
          };
        } else {
          data = JSON.parse(data);
        }

        return data;
      };

      service.SaveVerimatrix = function (data) {
        window.localStorage['verimatrix'] = JSON.stringify(data);
      };

      service.GetGoogleDrm = function () {
        var data = window.localStorage['googleDrm'];
        if (!data || data === 'undefined') {
          data = {
            provider: '',
            owner: '',
            licenseKey: ['', '']
          };
        } else {
          data = JSON.parse(data);
        }

        return data;
      };

      service.SaveGoogleDrm = function (data) {
        window.localStorage['googleDrm'] = JSON.stringify(data);
      };

      service.GetNagra = function () {
        var data = window.localStorage['nagra'];
        if (!data || data === 'undefined') {
          data = {
            prmServerURL: '',
          };
        } else {
          data = JSON.parse(data);
        }

        return data;
      };

      service.SaveNagra = function (data) {
        window.localStorage['nagra'] = JSON.stringify(data);
      };

      return service;
    }
  ]);